// == Import npm
import React, { useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

// == import i18n
import { useTranslation } from "react-i18next";

import { Typography } from "antd";

// == Import SCSS
import "./searchByVisitor.less";

// == Import assets
import { ReactComponent as Character } from "../../assets/illustrations/character-2.svg";

// == import component
import SearchBar from "../SearchBar/SearchBar";
import Tile from "../../common/Tile/Tile";

const SearchByVisitor = () => {
  const [t] = useTranslation();

  const [display, setDisplay] = useState(true);

  const { visitorList } = useSelector(state => state.visits);

  const type = "visitor";
  const searchText = t("SearchByFirstOrLastNameOfTheVisitor");

  const cssClassDisplay = classNames("searchByVisitor", {
    "searchByVisitor--display": !display,
  });

  const closeBubble = () => {
    setDisplay(true);
  };

  return (
    <div className={cssClassDisplay} onClick={closeBubble} style={{ height: window.innerHeight }}>
      <p className="searchByVisitor__texte">
        <Character className="searchByLostBadge__texte__img" />
        {t("WhatIsYourNamePlease")} ?
      </p>
      <SearchBar
        searchResult={visitorList}
        type={type}
        searchText={searchText}
        setDisplay={setDisplay}
      />
      <section className="searchByVisitor__section--btn">
        <Tile
          href="/SearchByResident"
          style={{
            height: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
            width: "300px",
          }}
        >
          <Typography.Text strong>
            {t("TheVisitorKnows")} <br /> {t("TheNameOfTheResident")}
          </Typography.Text>
        </Tile>
      </section>
    </div>
  );
};

export default SearchByVisitor;
